import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MockService } from '@mock/mock.service';
import { TranslationObject } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { HttpInterceptorParams } from '@app/core/interceptors/classes/http-interceptor-params';

@Injectable({
  providedIn: 'root',
})
export class I18nMockService extends MockService {
  constructor(private readonly httpClient: HttpClient) {
    super();
  }

  public getTranslationObject(lang: string): Observable<TranslationObject> {
    const url = `/locale/${lang}.json?date=${+new Date()}`;

    return this.httpClient.get<TranslationObject>(url, {
      params: new HttpInterceptorParams({ toIgnoreAll: true, toIgnoreNavigationCancellation: true }),
    });
  }
}
